var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb-container"},[(_vm.$route.name === 'month')?[_c('month-breadcrumbs')]:_vm._e(),(_vm.$route.name === 'tracker' && _vm.company.tracker)?[_c('tracker-breadcrumbs')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }